<script setup lang="ts">
import type { ISegmentControlsOption } from './models';
import { MMText } from '@mm-frontend/mm-web-ui-kit';

defineProps<{
  modelValue?: string;
  options: ISegmentControlsOption[];
  label?: string;
  error?: string;
}>();

defineEmits<{ (e: 'update:modelValue', value: ISegmentControlsOption): void }>();
</script>

<template>
  <div v-if="options?.length" class="segment-control">
    <MMText v-if="label" font="Body M/Regular" color="secondary">{{ label }}</MMText>

    <div class="segment-control__buttons">
      <button
        v-for="option in options"
        :key="option.value"
        :selected="option.value === modelValue"
        @click="$emit('update:modelValue', option.value)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
.segment-control
  display flex
  flex-direction column
  gap 8px
  position relative
  cursor text

  &__error
    position absolute
    bottom -18px
    left 0
    right 0

  &__buttons
    display grid
    grid-template-columns repeat(auto-fit, minmax(0, 1fr))
    overflow hidden
    border-radius var(--rounding150)
    border: solid 1px var(--border-regular)
    height 38px

    & button
      all unset
      font-family var(--typography-font)
      font-size: 14px
      outline none
      text-decoration none
      box-shadow none
      display flex
      cursor pointer
      align-items center
      transition-duration .2s
      text-align center
      justify-content center
      background-color white
      color var(--text-primary)
      white-space nowrap
      width 100%

      &:hover
        background-color var(--button-secondary-neutral-onprimary-hovered)

      &:nth-of-type(n+2)
        border-left solid 1px var(--border-regular)

      &[selected="true"]
        background-color var(--button-secondary-neutral-onprimary-hovered)
</style>
